import { useEffect } from "react";
import styled, { useTheme } from "styled-components";
import expandArrowImg from "../../../assets/img/expandArrow.svg";
import ReactSelect from "react-select";
import { components } from "react-select";

const SelectContainer = styled.div(() => ({
  flex: 1,
  marginLeft: "0.5em",
  margimRight: "0.5em",
  fontFamily: "NotoSansHebrew",
  fontSize: 16,
  fontWeight: "300",
}));

const StyledSelect = styled(ReactSelect)(() => ({
  fontFamily: "NotoSansHebrew",
  fontSize: 16,
  fontWeight: "300",
}));

const Error = styled.div(({ theme }) => ({
  fontSize: 12,
  color: theme.color.error,
  marginTop: "0.5em",
}));

const Label = styled.div(({ theme }) => ({
  fontSize: 16,
  fontFamily: "NotoSansHebrew",
  color: theme.color.text,
  textAlign: "start",
  fontWeight: 400,
  marginBottom: 5,
}));

const StyleStartImg = styled.img(() => ({
  width: 22,
  height: 22,
  marginInlineEnd: "1em",
  alignSelf: "center",
}));

const Select = ({
  label,
  value,
  error,
  name,
  options,
  onChange,
  width,
  height,
  helperText,
  startImg,
  placeholder,
  clearable,
  disabled,
  ...props
}) => {
  const theme = useTheme();

  useEffect(() => {
    if (options?.length === 1) {
      onChange(options[0]);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [options]);

  const DropdownIndicator = (props) => {
    return (
      <components.DropdownIndicator {...props}>
        <img src={expandArrowImg} alt="input-sown-img" style={{ width: 15, height: 15 }} />
      </components.DropdownIndicator>
    );
  };

  const Control = ({ children, ...props }) => {
    return (
      <components.Control {...props}>
        {!!startImg && <StyleStartImg src={startImg} alt="input-start-img" />}

        {children}
      </components.Control>
    );
  };

  return (
    <SelectContainer style={{ ...props.style }}>
      {label && <Label>{label}</Label>}
      <StyledSelect
        isClearable={clearable === false ? false : true}
        styles={{
          container: (base) => ({
            ...base,
            backgroundColor: theme.color.white,
            borderRadius: 6,
            width: width ? width : "100%",
            border: `1px solid ${!!helperText === true ? theme.color.error : theme.color.stroke}`,
          }),
          control: (base) => ({
            ...base,
            backgroundColor: theme.color.white,
            boxShadow: 0,
            padding: 5,
            paddingLeft: 10,
            paddingRight: 10,
            border: 0,
            borderRadius: 10,
            height: height ? height : "3em",
          }),
          input: (base) => ({
            ...base,
            textAlign: "start",
            color: theme.color.text,
            fontSize: 14,
          }),
          indicatorSeparator: () => {},
          menuList: (base) => ({
            ...base,
            marginRight: 5,
          }),
          placeholder: (base) => ({
            ...base,
            textAlign: "start",
            color: "#BDBFCE",
            fontSize: 14,
          }),
        }}
        closeMenuOnSelect={true}
        components={{ DropdownIndicator, Control }}
        options={options}
        mame={name}
        value={value}
        onChange={onChange}
        notEmpty={value !== "none"}
        placeholder={placeholder}
        isDisabled={disabled}
      ></StyledSelect>
      {!!helperText && <Error>{helperText}</Error>}
    </SelectContainer>
  );
};

export default Select;
